//Driver for second scores
//Intended to be accessed through scroing entry workflow
//Specifies an assessment/item, deliveries are randomly interspersed
//Not navigable

import axios from "axios";

export default {
	fa_icon: "fa-check-double",
	name: "Second Scoring",
	showScores() {
		return false;
	},
	sidebarType() {
		return "normal";
	},
	canBeEscalated: true,

	enter(vue, assessmentID, itemID) {
		vue.$router.push(`/second_score/${assessmentID}/${itemID}`);
	},

	getNext(ctx) {
		let aid = ctx.assessment_id;
		let iid = ctx.item_id;
		let params = {};

		if (ctx.skipqc) {
			params.skipqc = true;
		}
		var promise = axios.get(`/v3/reliability/${aid}/${iid}`, {
			params: params
		});
		promise.then(function(resp) {
			console.log("SecondSD GetNext:" + resp.data.response.ref_id);
		});
		return promise;
	},

	submitScore(score, response, keep) {
		score.response_id = response.id;

		var promise = axios.post("/v3/score", score, {
			params: { keep: keep }
		});
		promise.then(function(resp) {
			console.log("SecondSD Submitted");
		});
		return promise;
	}
};



// WEBPACK FOOTER //
// ./src/services/ScoringDrivers/SecondScoreDriver.js